export default "__VITE_ASSET__33c43989__"